/** Temporary "secret" used to "protect" the revalidate endpoint */
export const WEB_REVALIDATE_SECRET = "13c3a6b280e9";

export const INTER_FONT_FEATURE_SETTINGS =
  '"cv01" 1, "ss01" 0, "ss03" 1, "zero" 0, "liga" 0, "calt" 0, "cv10" 0, "cv05" 0';

/**
 * Font feature settings explanation:
 * See https://rsms.me/inter/ for more information
 * - "cv01" on: Alternate 1 (rounded top serif)
 * - "ss01" off: Alternate Digits (3,4,6,9)
 * - "ss03" on: Round Quotes & commas
 * - "zero" off: Slashed Zero
 * - "calt" off: contextual alternates
 * - "cv10" off: Capital G with Spur
 * - "cv05" on: lowercase l with tail
 */
